module.exports = __webpack_public_path__ + "static/img/share_guide_bar2.f0c979c9.png";